import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import WarningIcon from '@material-ui/icons/Warning';
import { withStyles } from '@material-ui/core/styles';
import { Spring, animated } from 'react-spring/renderprops';
import { ES_INFO_MESSAGE, EN_INFO_MESSAGE, PT_INFO_MESSAGE, ES_WARNING_MESSAGE, EN_WARNING_MESSAGE, PT_WARNING_MESSAGE } from '../utils/dominios';
import { withTranslation } from 'react-i18next';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon
};

const styles1 = theme => ({
  info: {
    backgroundColor: '#72616e'
  },
  warning: {
    backgroundColor: '#a2c5bf'
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1)
  },
  message: {
    display: 'flex',
    alignItems: 'center'
  },
  divContainer: {
    marginLeft: theme.spacing(6),
    marginRight: theme.spacing(6),
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      marginRight: 0
    },
    display: 'flex',
    justifyContent: 'flex-end'
  }
});

function MySnackbarContent(props) {
  const { classes, className, message, onClose, variant, ...other } = props;
  const Icon = variantIcon[variant];

  return (
    <Spring
      config={{ tension: 2000, friction: 1000 }}
      delay={300}
      from={{ opacity: 0 }}
      to={{ opacity: 1 }}
    >
      {springProps => (
        <animated.div style={springProps}>
          <div className={classes.divContainer}>
            <SnackbarContent
              className={classNames(classes[variant], className)}
              aria-describedby="client-snackbar"
              message={
                <span id="client-snackbar" className={classes.message}>
                  <Icon
                    className={classNames(classes.icon, classes.iconVariant)}
                  />
                  {message}
                </span>
              }
              {...other}
            />
          </div>
        </animated.div>
      )}
    </Spring>
  );
}

MySnackbarContent.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  message: PropTypes.node,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(['success', 'warning', 'error', 'info']).isRequired
};

const MySnackbarContentWrapper = withStyles(styles1)(MySnackbarContent);

const styles2 = theme => ({
  snackbar: {
    minWidth: '100%'
  }
});

class CustomizedSnackbars extends React.Component {
  render() {
    const { classes, i18n } = this.props;

    return (
      <div style={{ width: '100%' }}>
        {(i18n.language === 'es') && 
          <div>
            <MySnackbarContentWrapper
              variant="info"
              className={classes.snackbar}
              message={ES_INFO_MESSAGE}
            />
            <br />
            <MySnackbarContentWrapper
              variant="warning"
              className={classes.snackbar}
              message={ES_WARNING_MESSAGE}
            />
          </div>
        }
        {(i18n.language === 'en') && 
          <div>
            <MySnackbarContentWrapper
              variant="info"
              className={classes.snackbar}
              message={EN_INFO_MESSAGE}
            />
            <br />
            <MySnackbarContentWrapper
              variant="warning"
              className={classes.snackbar}
              message={EN_WARNING_MESSAGE}
            />
          </div>
        }
        {(i18n.language === 'pt') && 
          <div>
            <MySnackbarContentWrapper
              variant="info"
              className={classes.snackbar}
              message={PT_INFO_MESSAGE}
            />
            <br />
            <MySnackbarContentWrapper
              variant="warning"
              className={classes.snackbar}
              message={PT_WARNING_MESSAGE}
            />
          </div>
        }
      </div>
    );
  }
}

CustomizedSnackbars.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withTranslation()(withStyles(styles2)(CustomizedSnackbars));
